const autoComplete = require("@tarekraafat/autocomplete.js");
require("@tarekraafat/autocomplete.js/dist/css/autoComplete.02.css");
require("./style.scss");

const programFieldDom = require('./program_field.html');
const lotsFieldDom = require('./lots_field.html');

class SuperadminJumperFormBuilder {
  constructor(target, data) {
    this.target = target;
    this.programsData = data.programs;
    this.lotsData = data.lots;
    this.currentProgramSlug = data.current_program_slug;

    this.lotsAutocomplete = null;
  }

  setup() {
    var programField = $( programFieldDom );
    this.programsData.forEach((e) => {
      if (e.slug === this.currentProgramSlug)
      {
        programField.find("#superadmin-jumper-program").append(`<option value="${e.slug}" selected>${e.name}</option>`);
      }
      else
      {
        programField.find("#superadmin-jumper-program").append(`<option value="${e.slug}">${e.name}</option>`);
      }
    });

    programField.find("#superadmin-jumper-program").on('change', (e) => {
      var selectedProgramSlug = programField.find("#superadmin-jumper-program").find(":selected").val();
      this.selectProgram(selectedProgramSlug);
    });

    this.target.append(programField);
    this.target.append('<br>');

    var lotsField = $( lotsFieldDom );
    this.target.append(lotsField);
    this.target.append('<br>');
    this.target.append('<a href="#" class="btn btn-primary" id="superadmin-jumper-button">Valider</a>');

    this.selectProgram(this.currentProgramSlug);
  }

  programDataFromSlug(programSlug) {
    var result = null;
    this.programsData.forEach((programData) => {
      if (programData.slug === programSlug)
      {
        result = programData;
      }
    });

    return result;
  }

  selectProgram(programSlug) {

    var programData = this.programDataFromSlug(programSlug);

    var inputTarget = this.target.find("#superadmin-jumper-lot");
    var buttonTarget = this.target.find("#superadmin-jumper-button");
    if (this.lotsAutocomplete != null)
    {
      this.lotsAutocomplete.unInit();;
      delete this.lotsAutocomplete;
      this.lotsAutocomplete = null;
    }

    this.lotsAutocomplete = new autoComplete({
      selector: "#superadmin-jumper-lot",
      placeHolder: "Chercher un lot...",
      threshold: 0,
      resultsList: {
        maxResults: 100
      },
      data: {
        src: this.lotsData[programSlug],
        keys: ['reference']
      },
      resultItem: {
        highlight: 'text-primary'
      },
      events: {
        input: {
          selection: (event) => {
            const feedback = event.detail;
            const selection = feedback.selection.value[feedback.selection.key];
            this.lotsAutocomplete.input.value = selection;

            var href = feedback.selection.value.url;
            buttonTarget.attr('href', href);
            buttonTarget.text(`Aller au lot ${programData.name} / ${selection}`);
          },
        },
      }
    });

    inputTarget.val('');

    buttonTarget.attr('href', programData.url);
    buttonTarget.text(`Aller au programme ${programData.name}`);

    inputTarget.off('focusin').on('focusin', (e) => {
      this.lotsAutocomplete.start();
    });
  }
}


var buildSuperadminJumperForm = function (data) {
  var builder = new SuperadminJumperFormBuilder($(this), data);
  builder.setup();
  return builder;
};

export default buildSuperadminJumperForm;
